import angular from 'angular';
import env from './env';
import { convertStringToBoolean } from './util';
import appConfig from '../../_buildconfig/appconfig';

/**
 * Define app constants
 */

/**
 * Get environment variable, or return default value if not set
 * @param name
 * @param defaultValue
 * @returns {*}
 */
function getenv(name, defaultValue = null) {
  if (name in env) {
    return env[name];
  } else {
    return defaultValue;
  }
}

function getenvBool(name, defaultValue = null) {
  if (name in env) {
    return convertStringToBoolean(env[name]);
  } else {
    return defaultValue;
  }
}

export const API_URL = env.API_URL || "/api/v1";
export const APPLICATION_URL = API_URL.substr(0,API_URL.indexOf('/api/v1')) || '';
export const DEBUG = env.DEBUG === undefined
  ? false
  : convertStringToBoolean(env.DEBUG);
export const CACHE_ENABLED = env.CACHE_ENABLED === undefined
  ? true
  : convertStringToBoolean(env.CACHE_ENABLED);
export const DEFAULT_LOCALE = env.DEFAULT_LOCALE || 'en_US';

export const INCREMENTAL_PURGE_OLD_DATA_STORE = getenv('INCREMENTAL_PURGE_OLD_DATA_STORE', true);
export const INCREMENTAL_ENABLED = getenv('INCREMENTAL_ENABLED', false);

export const LOGS_DISABLE_ERRORS = getenvBool('LOGS_DISABLE_ERRORS', false);
export const LOGS_DISABLE_INFO = getenvBool('LOGS_DISABLE_INFO', false);
export const LOG_SLOW_REQUEST_THRESHOLD = env.LOG_SLOW_REQUEST_THRESHOLD || 30000;

// Recap response statuses
export const RECAP_RESPONSE_STATUS_SUBMITTED = 1;
export const RECAP_RESPONSE_STATUS_APPROVED = 2;

export const APP_CONFIG = appConfig;

/**
 * Reference all app constants here in order to expose them as Angular constants
 */
export const all = {
  API_URL,
  APPLICATION_URL,
  DEBUG,
  CACHE_ENABLED,
  DEFAULT_LOCALE,
  INCREMENTAL_PURGE_OLD_DATA_STORE,
  INCREMENTAL_ENABLED,
  LOGS_DISABLE_ERRORS,
  LOGS_DISABLE_INFO,
  LOG_SLOW_REQUEST_THRESHOLD,
  RECAP_RESPONSE_STATUS_SUBMITTED,
  RECAP_RESPONSE_STATUS_APPROVED,
  APP_CONFIG,
};

/**
 * Set up module and define all constants
 */
const moduleName = 'constants';
let module = angular.module(moduleName, []);
for (let key of Object.keys(all)) {
  module.constant(key, all[key]);
}

export default moduleName;
